var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 82,
    viewBox: "0 0 71 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0312 75.916H44.8752V81.1039H27.0312V75.916Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2942 53.1368C20.3719 51.2116 19.2404 49.3817 17.9315 47.6981C14.7591 43.6176 13.0666 38.5181 13.1663 33.339C13.4056 20.9032 23.7493 10.9047 36.2328 11.0584C48.5425 11.2066 58.7438 21.4971 58.7438 33.7842C58.7438 37.3667 57.931 40.7959 56.328 43.9767L51.6832 41.6458C52.9183 39.1948 53.5448 36.5497 53.5448 33.7841C53.5448 24.2286 45.7506 16.361 36.1703 16.2458C26.5337 16.1238 18.5491 23.8424 18.3644 33.4383C18.2864 37.4939 19.5572 41.3252 22.0394 44.5177C23.5753 46.4933 24.9028 48.6403 25.9851 50.899L21.2942 53.1368Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.583 53.2742L45.8828 51.057C46.6847 49.3642 47.6285 47.7154 48.6877 46.1562L52.991 49.0672C52.0812 50.4064 51.271 51.8218 50.583 53.2742Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5232 71.2662H29.3829C26.5519 71.2662 24.2485 68.9688 24.2485 66.1447V66.144C24.2485 63.7873 23.9695 61.427 23.4191 59.1283C23.0349 57.5236 24.2939 55.9316 25.9474 55.9316H45.9763C47.6336 55.9316 48.8935 57.5305 48.5025 59.1375C47.9419 61.4421 47.6577 63.7996 47.6577 66.1445C47.6575 68.9686 45.3544 71.2662 42.5232 71.2662ZM29.4474 66.0783H42.4585C42.4618 64.4238 42.5849 62.7657 42.8264 61.1194H29.0871C29.3236 62.7624 29.4442 64.4211 29.4474 66.0783Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3516 0H38.5506V6.96786H33.3516V0Z",
    fill: "#1D4ED8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9142 16.2136L9.73633 11.0507L13.4111 7.38086L18.589 12.544L14.9142 16.2136Z",
    fill: "#1D4ED8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 30.9297H8.7996V36.1176H0.945312V30.9297Z",
    fill: "#1D4ED8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1035 30.9297H70.9578V36.1176H63.1035V30.9297Z",
    fill: "#1D4ED8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9893 16.2136L53.3145 12.544L58.4923 7.38086L62.1671 11.0507L56.9893 16.2136Z",
    fill: "#1D4ED8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8886 40.6511L27.0508 36.3817L30.4951 32.4956L33.4407 35.0951L41.2333 26.7949L45.0275 30.3418L35.508 40.4816C34.7096 41.3871 33.1932 41.7186 31.8886 40.6511Z",
    fill: "#1D4ED8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon1);
export default __webpack_public_path__ + "static/media/about_icon1.e849526b1f8e1e604642e2bc99614122.svg";
export { ForwardRef as ReactComponent };